import { Injector } from '@angular/core';

export class InjectorService {
	static injector: Injector;
}
